import { TransactionType } from '../enums';

export function getMostRecentDescription<
  T extends { createdAt: Date | string, description?: string | null }
> (histories: T[]): string | null {
  const sorted = [...histories].sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
  );
  return sorted.find((h) => h.description?.trim())?.description ?? null;
}

export type PointsTotalsByType = {
  earned: number,
  redeemed: number,
  refunded: number,
  returned: number,
}

export function getPointsTotalsByType<T extends { amount: number, type: TransactionType }> (
  histories: T[],
): PointsTotalsByType {
  const totals: PointsTotalsByType = {
    earned: 0,
    redeemed: 0,
    refunded: 0,
    returned: 0,
  };
  histories.forEach((history) => {
    if ([
      TransactionType.CREDIT,
      TransactionType.CORRECTION,
    ].includes(history.type)) {
      totals.earned += history.amount;
    } else if ([
      TransactionType.DEBIT,
      TransactionType.DEBIT_CORRECTION,
      TransactionType.BOOKING_REDEMPTION,
    ].includes(history.type)) {
      totals.redeemed += (history.amount * -1);
    } else if (history.type === TransactionType.BOOKING_REFUND) {
      totals.redeemed += history.amount;
    } else if ([
      TransactionType.REDEMPTION_REFUND,
      TransactionType.REDEMPTION_REFUND_CORRECTION,
    ].includes(history.type)) {
      totals.refunded += history.amount;
    } else if ([
      TransactionType.RETURN,
      TransactionType.RETURN_CORRECTION,
    ].includes(history.type)) {
      totals.returned += (history.amount * -1);
    }
  });
  return totals;
}
